// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"26213a28","150":"022ce580","182":"40e0da77","311":"2c710ceb","312":"9eff88af","332":"5d852ef0","705":"0834f928"}[chunkId] + ".chunk.js";
};